import { Navigate } from 'react-router-dom'

import { useRemoteConfig } from '@/contexts/RemoteConfigContext'
import { usePermissions } from '@/hooks/usePermissions'

const PaymentGuard = ({ children }: { children?: React.ReactNode }) => {
  const { enablePayments } = useRemoteConfig()
  const { permissions } = usePermissions()

  if (!permissions.CAN_MANAGE_BILLING) {
    return <Navigate to="/" replace />
  }

  if (!enablePayments) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default PaymentGuard
